var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eyedropper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.856 10.8565L17.3142 11.3147C17.4535 11.454 17.564 11.6193 17.6394 11.8013C17.7148 11.9833 17.7536 12.1784 17.7536 12.3753C17.7536 12.5723 17.7148 12.7674 17.6394 12.9494C17.564 13.1314 17.4535 13.2967 17.3142 13.436L16.6552 14.095C16.5146 14.2357 16.3238 14.3147 16.1249 14.3147C15.926 14.3147 15.7352 14.2357 15.5946 14.095L9.90522 8.40567C9.76456 8.26502 9.68555 8.07425 9.68555 7.87534C9.68555 7.67643 9.76456 7.48566 9.90522 7.34501L10.5642 6.686C10.7035 6.54671 10.8689 6.43622 11.0509 6.36084C11.2328 6.28546 11.4279 6.24666 11.6249 6.24666C11.8219 6.24666 12.0169 6.28546 12.1989 6.36084C12.3809 6.43622 12.5463 6.54671 12.6855 6.686L13.1437 7.14418L15.7301 4.5578C16.7415 3.5464 18.3894 3.48444 19.4282 4.46773C19.6832 4.70881 19.8873 4.99857 20.0284 5.31989C20.1695 5.6412 20.2447 5.98755 20.2496 6.33844C20.2546 6.68934 20.1891 7.03766 20.0571 7.36281C19.9251 7.68797 19.7292 7.98335 19.481 8.2315L16.856 10.8565Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.8711 13.3716L9.62105 18.6216C9.24878 18.9941 8.78495 19.2621 8.27622 19.3985C7.7675 19.5349 7.23182 19.5349 6.7231 19.3985L4.52913 20.3563C4.39097 20.4166 4.23784 20.4339 4.08971 20.4058C3.94158 20.3778 3.80533 20.3058 3.69873 20.1992V20.1992C3.6222 20.1227 3.5705 20.0249 3.55039 19.9185C3.53028 19.8122 3.54269 19.7022 3.58599 19.603L4.60149 17.2769C4.46509 16.7682 4.46509 16.2325 4.60147 15.7237C4.73786 15.215 5.00583 14.7512 5.37841 14.3789L10.6284 9.12891",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.56b73b23836ecd9df519c1614489a6ac.svg";
export { ForwardRef as ReactComponent };